<template>
  <div class="authstr-container">
    <header>
      <span class="title">待发布应用</span>
      <div class="right">
        <el-input class="seach" size="small" v-model="searchInput" placeholder="应用名称/上传人" suffix-icon="el-icon-search" @keyup.enter.native="search"></el-input>
        <el-button :disabled="disabled" @click="dialogDelete = true" v-if="funAuth.includes(33)">删  除</el-button>
      </div>
    </header>
    <el-table ref='multipleTable' :data='tableList' tooltip-effect='dark' style='width: 100%' @selection-change='handleSelectionChange' @row-click="audit" class="el-table-01">
      <el-table-column type='selection' width='55'></el-table-column>
      <el-table-column label='名称'>
        <template  slot-scope='scope'>
            <span class="ellipsis" :style="ellipsisStyle">{{scope.row.template_name}}</span>
        </template>
      </el-table-column>
      <el-table-column prop='version' label='版本号'></el-table-column>
      <el-table-column  label='介绍'>
        <template  slot-scope='scope'>
          <span class="ellipsis" :style="ellipsisStyle">{{scope.row.introduce}}</span>
        </template>
      </el-table-column>
      <el-table-column prop='fit_industry' label='应用类型'>
        <template  slot-scope='scope'>
          <span class="ellipsis" :style="ellipsisStyle" v-text="classifyInfo(scope.row.classifyInfo, 1)"></span>
        </template>
      </el-table-column>
      <el-table-column prop='func_type' label='所属行业'>
        <template  slot-scope='scope'>
          <span class="ellipsis" :style="ellipsisStyle" v-text="classifyInfo(scope.row.classifyInfo, 2)"></span>
        </template>
      </el-table-column>
      <el-table-column prop='charge_type' label='类型'></el-table-column>
      <el-table-column prop='upload_user' label='开发者'></el-table-column>
    </el-table>
    <el-pagination @size-change='handleSizeChange' @current-change='handleCurrentChange' :current-page='pageNum' :page-sizes='[10, 20, 50, 100]' :page-size='pageSize' layout='total, sizes, prev, pager, next, jumper' :total='tableTotal'></el-pagination>

    <el-dialog title="提示" :visible.sync="dialogDelete" class="prompt-box">
      <i class="iconfont icon-prompt-box"></i>
      <div class="content">删除</div>
      <div class="note" style="min-height: 5px;"></div>
      <div class="prompt">确定要删除该待审批应用吗？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogDelete = false">取 消</el-button>
        <el-button type="primary" @click="applyDelete">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {HTTPServer} from '@/common/js/ajax.js'
import {appIndustry} from '@/common/js/constant.js'
import mixin from '@/common/js/mixins.js'
export default {
  data () {
    return {
      defaultMsg: '<b>待发布应用</b>',
      ellipsisStyle: '-webkit-line-clamp: 5;-webkit-box-orient: vertical;',
      searchInput: '',
      tableList: [],
      pageSize: 20,
      pageNum: 1,
      tableTotal: 0,
      options1: [
        {id: '0', label: '免费'},
        {id: '1', label: '付费'}
      ],
      disabled: true,
      dialogDelete: false
    }
  },
  mixins: [mixin],
  mounted () {
    this.searchValue = ''
    this.queryApplicationList()
    this.queryFchBtnAuth(({moduleId: 9}))
  },
  methods: {
    /** 获取列表 */
    queryApplicationList () {
      var jsondata = {'pageNum': this.pageNum, 'pageSize': this.pageSize, 'keyWord': this.searchValue}
      HTTPServer.queryApplicationList(jsondata, 'Loading').then((res) => {
        this.tableList = res.dataList
        for (var i = 0; i < this.tableList.length; i++) {
          for (var j = 0; j < appIndustry.industry.length; j++) {
            if (this.tableList[i].fit_industry === appIndustry.industry[j].id) {
              this.tableList[i].fit_industry = appIndustry.industry[j].label
            }
          }
          for (var k = 0; k < appIndustry.classification.length; k++) {
            if (this.tableList[i].func_type === appIndustry.classification[k].id) {
              this.tableList[i].func_type = appIndustry.classification[k].label
            }
          }
          for (var s = 0; s < this.options1.length; s++) {
            if (this.tableList[i].charge_type.toString() === this.options1[s].id) {
              this.tableList[i].charge_type = this.options1[s].label
            }
          }
        }
        var pageInfo = res.pageInfo
        this.tableTotal = pageInfo.totalRows
      })
    },
    /** 搜索 */
    search () {
      this.searchValue = JSON.parse(JSON.stringify(this.searchInput))
      this.pageNum = 1
      this.pageSize = 20
      this.queryApplicationList()
    },
    /** 列表选择 */
    handleSelectionChange (val) {
      this.multipleSelection = val
      this.disabled = (this.multipleSelection.length === 0)
    },
    /** 显示每页条数 */
    handleSizeChange (val) {
      this.pageSize = val
      this.pageNum = 1
      this.queryApplicationList()
    },
    /** 跳转第几页 */
    handleCurrentChange (val) {
      this.pageNum = val
      this.queryApplicationList()
    },
    // 行的点击事件
    audit (val) {
      console.log(val)
      this.$router.push({name: 'ApplyDetail', query: {'id': val.id}, params: {detail: 3}})
    },
    /** 删除 */
    applyDelete () {
      var id = []
      for (var i = 0; i < this.multipleSelection.length; i++) {
        id.push(this.multipleSelection[i].id)
      }
      var jsondata = {'id': id.toString()}
      HTTPServer.deleteApplication(jsondata, 'Loading').then((res) => {
        this.$message({
          showClose: true,
          message: '操作成功！',
          type: 'success'
        })
        this.queryApplicationList()
        this.dialogDelete = false
      })
    },
    classifyInfo (arr, type) {
      var text = []
      arr.map(v => {
        if (v.classify_type === type) {
          text.push(this.languageFilter(v.classify_name))
        }
      })
      return text.toString()
    },
    // 语言过滤
    languageFilter (name) {
      if (JSON.stringify(name).includes('{\\"language\\"')) {
        if (typeof name === 'string') {
          return JSON.parse(name).language.zh
        } else {
          return name.language.zh
        }
      } else {
        return name
      }
    }
  }
}
</script>

<style lang="scss">
.authstr-container{
  .ellipsis{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/application/authstr-apply.vue